<template>
    <div class="weather-city-search" @focusout="onFocusOut">
        <div class="weather-city-search-input-wrap">
            <svg class="weather-city-search-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="10" cy="10" r="7"/><path d="m16 16 5 5"/></svg>
            <input ref="input"
                   class="weather-city-search-input"
                   :placeholder="$t('common.weather.search')"
                   v-model="query"
                   @input="onInput"
                   @keydown.esc.stop="onClose"
                   @keydown.down.prevent="moveDown"
                   @keydown.up.prevent="moveUp"
                   @keydown.enter.prevent="selectHighlighted"/>
            <button v-if="query.length" class="weather-city-search-clear" @click="onClose">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
        </div>
        <div class="weather-city-search-results" v-if="results.length">
            <button v-for="(r, i) in results" :key="r.city_id + '-' + r.district_id"
                    class="weather-city-search-item"
                    :class="{'weather-city-search-item--active': highlightIndex === i}"
                    @click="select(r)"
                    @mouseenter="highlightIndex = i">
                <span class="weather-city-search-item-name">{{ r.label }}</span>
            </button>
        </div>
        <div class="weather-city-search-empty" v-else-if="query.length >= 2 && !loading && searched">
            {{ $t('common.weather.noResults') }}
        </div>
        <div class="weather-city-search-loading" v-else-if="loading">
            {{ $t('common.weather.loading') }}
        </div>
    </div>
</template>

<script>
import weatherService from './weatherService'

export default {
    name: 'WeatherCitySearch',
    emits: ['select', 'close'],
    data() {
        return {
            query: '',
            results: [],
            loading: false,
            searched: false,
            highlightIndex: 0,
            debounceTimer: null,
        }
    },
    mounted() {
        this.$nextTick(() => this.$refs.input?.focus())
    },
    beforeUnmount() {
        clearTimeout(this.debounceTimer)
    },
    methods: {
        onClose() {
            this.query = ''
            this.results = []
            this.searched = false
            this.$emit('close')
        },
        onFocusOut(e) {
            if (this.$el.contains(e.relatedTarget)) return
            if (!this.query && !this.results.length) {
                this.$emit('close')
            }
        },
        onInput() {
            clearTimeout(this.debounceTimer)
            if (this.query.length < 2) {
                this.results = []
                this.searched = false
                return
            }
            this.loading = true
            this.debounceTimer = setTimeout(() => this.doSearch(), 350)
        },
        async doSearch() {
            const q = this.query.trim()
            if (q.length < 2) return
            this.results = await weatherService.searchCity(q)
            this.loading = false
            this.searched = true
            this.highlightIndex = 0
        },
        select(r) {
            const parts = r.label.split(', ')
            this.$emit('select', {
                cityId: r.city_id,
                districtId: r.district_id,
                cityName: parts.length > 1 ? parts[1] : parts[0],
                districtName: parts[0],
            })
        },
        moveDown() {
            if (this.highlightIndex < this.results.length - 1) this.highlightIndex++
        },
        moveUp() {
            if (this.highlightIndex > 0) this.highlightIndex--
        },
        selectHighlighted() {
            if (this.results[this.highlightIndex]) this.select(this.results[this.highlightIndex])
        },
    },
}
</script>
